import styled from 'styled-components';

import { GlobalToken } from 'antd';

export const RulesOverviewContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: ${({ theme: { token } }) => token.paddingMD}px;

  .order-notification-container {
    margin-left: ${({ theme: { token } }) => token.margin}px;
    margin-right: ${({ theme: { token } }) => token.margin}px;
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
  }

  .flex-row {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    }
  }

  .pressure-ranges {
    display: flex;
    overflow-x: scroll;
    margin-left: ${({ theme: { token } }) => token.margin}px;
    gap: ${({ theme: { token } }) => token.margin}px;
  }

  .edit-mode-switch-container {
    display: flex;
    align-items: center;
    align-self: flex-end;

    .switch-label {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      color: ${({ theme: { token } }) => token.colorBorder};
    }

    .edit-mode-switch {
      margin: 0 ${({ theme: { token } }) => token.marginXS}px;
    }

    .ant-switch {
      background-color: ${({ theme: { token } }) => token.colorBgElevated};
      height: 10px;
      width: 20px;

      .ant-switch-handle::before {
        background-color: ${({ theme: { token } }) => token.colorPrimary};
        top: -5px;
        left: -2px;
        height: 16px;
        width: 16px;
        border-radius: 50%;
      }

      .ant-switch-loading-icon {
        top: 16px;
        left: 18px;
      }
    }

    .ant-switch-checked {
      .ant-switch-handle::before {
        background-color: ${({ theme: { token } }) => token.colorPrimary};
      }

      .ant-switch-loading-icon {
        color: ${({ theme: { token } }) => token.colorText};
        top: 10px;
        left: 2px;
      }

      &:focus {
        box-shadow: unset;
      }
    }

    .ant-switch-inner {
      color: ${({ theme: { token } }) => token.colorBgElevated};
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    }
  }
`;
